import { Box, FormControlLabel, Grid, Stack, Switch } from "@mui/material";
import { useForm, SubmitHandler, FormProvider } from "react-hook-form";
import RegistryData from "./scaleComponents/registryComponent";
import { theme } from "@/theme";
import InfoBodyData from "./scaleComponents/bofyInfoComponent";
import SmokeData from "./scaleComponents/smokeComponent";
import PressureData from "./scaleComponents/pressureComponent";
import CholesterolData from "./scaleComponents/cholesterolComponent";
import CreatinineData from "./scaleComponents/creatinineComponent";
import { useTranslatedMessages } from "@/multiLanguage/i18n";
import CardiovascularEventsData from "./scaleComponents/cardiovascularEventComponent";
import { CustomButton } from "@/components";
import { ClientData } from "@/services/pharmacyService";
import { useEffect } from "react";
import PrivacyData from "./scaleComponents/privacyComponent";
import FooterFormData from "./scaleComponents/footerFormComponent";
import { constants } from "@/utils/constants";

const DefaultFormData: FormDataLopre = {
    //ANAGRAFICA
    name: "Test",
    surname: "Test",
    country: "italy",
    sex: "male",
    age: 41,
    //Dati fisici
    height: 189,
    weight: 83,
    //Dati fumatore
    actualSmoker: false,
    exSmokerSwitch: false,
    exSmokerYears: 0,
    //Pressione
    systolicPressure: 150,
    diastolicPressure: 150,

    //Cholesterol
    totalCholesterol: 116,
    hdlCholesterol: 27,
    //ldlCholesterol?: number,
    triglycerides: 150,
    //noHdlCholesterol?: number,
    //creatine
    creatinine: 10,
    //eventi cardiovasculari
    //cardiovascularEvent: false, // NON SERVE DA VEDERE COSA FARE LATO BK E SE SI PUO TOGLIERE
    cardiovascularEventSwitch: false,
    moreCardiovascularEvent: false,
    //diabet data
    //diabetes: false, // NON SERVE DA VEDERE COSA FARE LATO BK E SE SI PUO TOGLIERE
    diabetesSwitch: false,
    //privacy
    privacy_switch: false,
};
export type FormDataLopre = {
    //ANAGRAFICA
    name?: string;
    surname?: string;
    country: string;
    sex: string;
    age: number;
    //Dati fisici
    height?: number;
    weight?: number;
    //Dati fumatore
    actualSmoker: boolean;
    exSmokerSwitch: boolean;
    exSmokerYears?: number;
    //Pressione
    systolicPressure: number;
    diastolicPressure?: number;
    //Cholesterol
    totalCholesterol: number;
    hdlCholesterol: number;
    ldlCholesterol?: number;
    triglycerides: number;
    noHdlCholesterol?: number;
    //creatine
    creatinine?: number;
    //eventi cardiovasculari
    //cardiovascularEvent: boolean, // NON SERVE DA VEDERE COSA FARE LATO BK E SE SI PUO TOGLIERE
    cardiovascularEventSwitch: boolean;
    moreCardiovascularEvent: boolean;
    //diabet
    //diabetes: boolean, // NON SERVE DA VEDERE COSA FARE LATO BK E SE SI PUO TOGLIERE
    diabetesSwitch?: boolean;
    privacy_switch?: boolean;
};

type FormProps = {
    onSubmit: SubmitHandler<FormDataLopre>;
    selectedClient?: ClientData;
    /** Solo per strumenti dev: riempie l'intero form con un caso predefinito. */
    prefillData?: FormDataLopre;
};

export function LopreScaleHookForm({ onSubmit, selectedClient, prefillData }: FormProps) {
    const formMethods = useForm<FormDataLopre>({
        mode: "onBlur",
        defaultValues: constants.IS_DEBUG ? { ...DefaultFormData } : undefined,
    });
    const lang = useTranslatedMessages();
    useEffect(() => {
        if (selectedClient) {
            formMethods.setValue("name", selectedClient.name);
            formMethods.setValue("surname", selectedClient.surname);
            formMethods.setValue("country", selectedClient.nationality);
        }
    }, [selectedClient]);

    useEffect(() => {
        if (prefillData) {
            formMethods.reset({ ...prefillData });
        }
    }, [prefillData]);

    return (
        <FormProvider {...formMethods}>
            <Box
                sx={{
                    borderRadius: "20px 20px 20px 20px",
                    backgroundColor: theme.palette.primary.light,
                }}
            >
                <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                    <Stack gap={3} p={3}>

                        <Grid container spacing={3} >

                            <Grid item xs={12} md={6} >
                                <Box >
                                    <Stack gap={3}>
                                        <RegistryData
                                            disabledPatientData={selectedClient ? true : false}
                                            defaultCountry={selectedClient?.nationality}
                                            nameRequired={false}
                                            surnameRequired={false}
                                        />
                                        <InfoBodyData heightRequired={false} weightRequired={false} />
                                    </Stack>
                                </Box>

                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Box >
                                    <Stack gap={3}>
                                        <PressureData diastolicPressureRequired={false} />
                                        <CholesterolData />
                                        <CreatinineData />
                                    </Stack>
                                </Box>

                            </Grid>
                            <Grid item xs={12} >
                                <Box>
                                    <Stack >
                                        <SmokeData />
                                        <Stack>
                                            <FormControlLabel
                                                control={<Switch {...formMethods.register("diabetesSwitch")} />}
                                                label={lang.scales.scaleWithComponentShared.diabete2.label}
                                                labelPlacement="start"
                                                sx={{
                                                    marginLeft: 0,
                                                    marginTop: "10px",
                                                    marginBottom: "10px",
                                                    flexGrow: 1,
                                                    "&.MuiFormControlLabel-labelPlacementStart": {
                                                        justifyContent: "space-between",
                                                    },
                                                }}
                                            />
                                        </Stack>
                                        <CardiovascularEventsData arteriopathy={false} />

                                        <PrivacyData />
                                        <FooterFormData />
                                    </Stack>
                                </Box>

                            </Grid>
                        </Grid>
                    </Stack>
                    <Stack flexDirection={"row"} justifyContent={"center"} mt={2}>
                        <Box>
                            <CustomButton
                                sx={{
                                    backgroundColor: theme.palette.secondary.dark,
                                    color: theme.palette.primary.light,
                                }}
                                label={lang.scales.shared.forms.calculate}
                                type="submit"
                            />
                        </Box>
                        {/* <Box >
                            <CustomButton
                                sx={{ backgroundColor: theme.palette.secondary.dark, color: theme.palette.primary.light }}

                                label="Errori"
                                onClick={() => printErrors(formMethods.formState.errors)}
                            />

                        </Box> */}
                    </Stack>
                </form>
            </Box>
        </FormProvider>
    );
}
